import {clsx, type ClassValue} from 'clsx';
import {twMerge} from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatReadableDateRange(value?: string) {
  if (!value) return 'N/A';

  const [start, end] = value.split(' - ').map((v) => v.trim());
  const options: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    timeZone: 'UTC', // Force UTC to avoid timezone issues
  };

  const format = (d: string) => {
    if (!d || d === 'undefined' || d === 'null') return '';
    
    // Handle both ISO date strings and YYYY-MM-DD format
    let date: Date;
    if (d.includes('T')) {
      // ISO string - parse as UTC
      date = new Date(d);
    } else {
      // YYYY-MM-DD format - treat as UTC date
      date = new Date(d + 'T00:00:00.000Z');
    }
    
    return isNaN(date.getTime())
      ? ''
      : date.toLocaleDateString('en-US', options);
  };

  const formattedStart = format(start);
  const formattedEnd = format(end);

  if (formattedStart && formattedEnd)
    return `${formattedStart} - ${formattedEnd}`;
  if (formattedStart) return formattedStart;
  if (formattedEnd) return formattedEnd;

  return 'N/A';
}
